import type { RegistrationMode } from '@/types/registration';

export const getRegistrationActionVisibility = (mode: RegistrationMode) => ({
  showNext: true,
  showSave: mode === 'legacy',
  showCoupon: mode !== 'external-subaccount',
});
